import React from "react";
import { colors } from "../../colors";

type Props = {
  size?: number;
  color?: string;
  // Turns the arrow upright for the crack width; length keeps it horizontal.
  vertical?: boolean;
  strokeWidth?: number;
};

// Web counterpart of the native SVG icon — same geometry as an inline <svg> so
// the webpack build does not need react-native-svg.
export default function MeasureIcon({
  size = 20,
  color = colors.deepGreen,
  vertical,
  strokeWidth = 0.6875,
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flexShrink: 0,
        transform: vertical ? "rotate(90deg)" : undefined,
      }}
    >
      <path
        d="M2.292 8.5H14.708"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 11.708L2.292 8.5L5.5 5.292"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 5.292L14.708 8.5L11.5 11.708"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
